// extracted by mini-css-extract-plugin
module.exports = {"content":"Modal_healthgenom_content__1deOB","buttons":"Modal_healthgenom_buttons__1mEMv"};